import { useMutation } from "react-query";

import getUser from "../services/getUser";

function useGetUser() {
  return useMutation(["get-user"], getUser);
}

export default useGetUser;
